import __request__ from "routing/request";
export function getPage(collection, column = "title", page = 1, per_page = 10, query) {
  return __request__("GET", "/entity_suggestions", null, { "collection": collection, "column": column, "page": page, "per_page": per_page, "query": query }, {
    "Accept": ["application/json"]
  });
}
